import { render, staticRenderFns } from "./CancelOrders.vue?vue&type=template&id=19660c57"
import script from "./CancelOrders.vue?vue&type=script&lang=js"
export * from "./CancelOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports